import {css} from "@panda/css";

import {SearchComboboxDivider} from "@pg-design/search-combobox-module";

import type {IPricesSearchNearbyItem, IPricesSearchSection} from "../../types/IPricesSearchModel";
import {PricesSearchNearbyRow} from "./PricesSearchNearbyRow";
import {type IPricesSearchListProps, PricesSearchSectionList} from "./PricesSearchSectionList";

interface IProps extends IPricesSearchListProps {
    nearby?: IPricesSearchNearbyItem;
    /** Recent searches (when there are any) and the popular cities. */
    sections: readonly IPricesSearchSection[];
}

/** Focus with an empty field: "Ceny w mojej okolicy", recent searches, popular locations. */
export const PricesSearchFocusContent = (props: IProps) => {
    const {nearby, sections, ...listProps} = props;

    return (
        <>
            {nearby ? (
                <>
                    <div className={nearbyStyle}>
                        <PricesSearchNearbyRow item={nearby} optionProps={listProps.combobox.getOptionProps(nearby.id)} mode={listProps.mode} />
                    </div>
                    {sections.length > 0 ? <SearchComboboxDivider /> : null}
                </>
            ) : null}
            <PricesSearchSectionList sections={sections} {...listProps} />
        </>
    );
};

// Same padding as a group (pt 4, px 8, pb 8), so the row lines up with the rows below and its highlight never touches the divider.
const nearbyStyle = css({
    pt: "0.4rem",
    px: "0.8rem",
    pb: "0.8rem"
});
import {css} from "@panda/css";

import {SearchComboboxDivider} from "@pg-design/search-combobox-module";

import type {IPricesSearchNearbyItem, IPricesSearchSection} from "../../types/IPricesSearchModel";
import {PricesSearchNearbyRow} from "./PricesSearchNearbyRow";
import {type IPricesSearchListProps, PricesSearchSectionList} from "./PricesSearchSectionList";

interface IProps extends IPricesSearchListProps {
    nearby?: IPricesSearchNearbyItem;
    /** Recent searches (when there are any) and the popular cities. */
    sections: readonly IPricesSearchSection[];
}

/** Focus with an empty field: "Ceny w mojej okolicy", recent searches, popular locations. */
export const PricesSearchFocusContent = (props: IProps) => {
    const {nearby, sections, ...listProps} = props;

    return (
        <>
            {nearby ? (
                <>
                    <div className={nearbyStyle}>
                        <PricesSearchNearbyRow item={nearby} optionProps={listProps.combobox.getOptionProps(nearby.id)} mode={listProps.mode} />
                    </div>
                    {sections.length > 0 ? <SearchComboboxDivider /> : null}
                </>
            ) : null}
            <PricesSearchSectionList sections={sections} {...listProps} />
        </>
    );
};

// Same padding as a group (pt 4, px 8, pb 8), so the row lines up with the rows below and its highlight never touches the divider.
const nearbyStyle = css({
    pt: "0.4rem",
    px: "0.8rem",
    pb: "0.8rem"
});
